/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum StageType {
    Group = 'GROUP',
    Knockout = 'KNOCKOUT',
    Placement = 'PLACEMENT'
}


export function instanceOfStageType(value: any): boolean {
    for (const key in StageType) {
        if (Object.prototype.hasOwnProperty.call(StageType, key)) {
            if (StageType[key as keyof typeof StageType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StageTypeFromJSON(json: any): StageType {
    return StageTypeFromJSONTyped(json, false);
}

export function StageTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): StageType {
    return json as StageType;
}

export function StageTypeToJSON(value?: StageType | null): any {
    return value as any;
}

export function StageTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): StageType {
    return value as StageType;
}

